module.exports = __webpack_public_path__ + "static/img/sprite.e23b38f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sprite.png
// module id = 1095
// module chunks = 30